import {
  event_status,
  EventStatusLandingTab,
} from '../../../assets/constData/event_status';

/** Event detail sidebar tab ids (see assets/constData/event_tabs.ts). */
export const EVENT_TAB_ID = {
  OVERVIEW: 1,
  SCHEDULE: 2,
  PARTICIPANTS: 3,
  LIVE_MATCHES: 4,
  DRAWS_RESULTS: 5,
  AWARDS: 6,
  LEADERBOARD: 7,
} as const;

export type EventTabId = (typeof EVENT_TAB_ID)[keyof typeof EVENT_TAB_ID];

export enum EventLandingStrategy {
  /** Tenant-specific first tab (ETTU → Schedule, others → Overview when available). */
  FIRST_TAB = 'FIRST_TAB',
  /** Always Draws & Results; overrides tenant first-tab rules. */
  DRAWS_RESULTS = 'DRAWS_RESULTS',
}

/**
 * Built once at module load — O(1) lookup by API event_status value.
 * Source of truth remains event_status.ts (landingTab per row).
 */
export const EVENT_STATUS_LANDING_BY_VALUE: ReadonlyMap<
  number,
  EventStatusLandingTab
> = new Map(
  event_status.map((status) => [status.value, status.landingTab] as const),
);
